export const FORWARD = 1;
export const FORWARD_REVERSE = 2;
export const FORWARD_STAY = 3;

export const ADD = 1;
export const MULTIPLY = 2;
